import * as notifications from "../services/NotificationService";
import moment from "moment";
import Notification from "../models/Notification";
import { normalizeJson } from "../../shared/helpers";
import EventBus from "../../shared/eventbus";
import { useRepo } from "pinia-orm";

export default {
    methods: {
        visitNotificationSource(notification) {
            const notificationType = notification.type.split('\\').slice(-1)[0];
            if (notificationType.indexOf('Task') > -1 && !notification.data.application) {
                notifications.update(notification.id, {
                    data: { attributes: { read_at: moment().format('YYYY-MM-DD HH:mm:ss') } }
                }).then(result => {
                    useRepo(Notification).save(normalizeJson(result));
                });

                return EventBus.dispatch('open-tasks-popout');
            }

            if (notificationType === 'ExportDataFinished') {
                window.location.href = notification.data.export.download_url;
                return notifications.update(notification.id, {
                    data: {attributes: {read_at: moment().format('YYYY-MM-DD HH:mm:ss')}}
                }).then(result => {
                    useRepo(Notification).save(normalizeJson(result));
                });
            }

            let redirect = notification.data.hasOwnProperty('application')
                ? this.$router.push({ name: 'application', params: { id: notification.data.application.id } })
                : this.$router.push({ name: 'job', params: { id: notification.data.job.id } });

            return redirect.catch(error => { }).finally(() => {
                notifications.update(notification.id, {
                    data: { attributes: { read_at: moment().format('YYYY-MM-DD HH:mm:ss') } }
                }).then(result => {
                    useRepo(Notification).save(normalizeJson(result));
                });
            });
        },
    }
}
